import classNames from 'classnames';
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var TabIndicator = function TabIndicator(props) {
  return /*#__PURE__*/_jsx("div", {
    className: classNames('tab-indicator-container', props.className),
    children: /*#__PURE__*/_jsx("div", {
      className: classNames('tab-indicator-bar', {
        'tab-indicator-bar-animate': props.animate
      })
    })
  });
};